export const Logo = ({ size = 34 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    aria-hidden="true"
    data-testid="logo-mark"
  >
    <defs>
      <linearGradient id="lg-sky" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#120E1A" />
        <stop offset="0.5" stopColor="#5A2418" />
        <stop offset="0.7" stopColor="#FF7A1A" />
      </linearGradient>
      <linearGradient id="lg-sea" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#B8481A" />
        <stop offset="1" stopColor="#140E14" />
      </linearGradient>
      <radialGradient id="lg-sun" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stopColor="#FFF4C8" />
        <stop offset="0.55" stopColor="#FFC24A" />
        <stop offset="1" stopColor="#FF7A1A" />
      </radialGradient>
      <clipPath id="lg-clip">
        <rect width="64" height="64" rx="14" />
      </clipPath>
    </defs>
    <rect width="64" height="64" rx="14" fill="url(#lg-sky)" />
    <g clipPath="url(#lg-clip)">
      <circle cx="41" cy="44" r="9.5" fill="url(#lg-sun)" />
      <rect x="0" y="44" width="64" height="20" fill="url(#lg-sea)" />
      <rect x="35.5" y="46.5" width="11" height="1.6" rx="0.8" fill="#FFB347" opacity="0.85" />
      <rect x="37" y="50.5" width="8" height="1.3" rx="0.65" fill="#FF9A3C" opacity="0.6" />
      <rect x="38.5" y="54.5" width="5" height="1" rx="0.5" fill="#FF8A2A" opacity="0.4" />
      <path d="M51 5 a5.2 5.2 0 1 0 5.2 7.2 a4 4 0 1 1 -5.2 -7.2z" fill="#FFE9B8" />
      <path d="M11 62 C 12 50, 15 37, 24 25" stroke="#0B0709" strokeWidth="3.2" fill="none" strokeLinecap="round" />
      <path d="M24 25 C 31 17, 40 15, 49 20 C 40 18, 32 20, 24 25z" fill="#0B0709" />
      <path d="M24 25 C 26 15, 32 9, 42 8 C 33 12, 28 17, 24 25z" fill="#0B0709" />
      <path d="M24 25 C 16 16, 8 15, 1 21 C 9 18, 17 20, 24 25z" fill="#0B0709" />
      <path d="M24 25 C 17 29, 11 34, 9 43 C 12 35, 18 29, 24 25z" fill="#0B0709" />
      <path d="M24 25 C 31 28, 37 32, 41 39 C 37 31, 31 27, 24 25z" fill="#0B0709" />
      <path d="M24 25 C 22 16, 18 11, 11 9 C 18 13, 21 18, 24 25z" fill="#0B0709" />
      <circle cx="24" cy="25" r="1.8" fill="#0B0709" />
    </g>
    <rect x="0.5" y="0.5" width="63" height="63" rx="13.5" stroke="#FF8A2A" strokeOpacity="0.35" />
  </svg>
);
